import Register from "../../public/register";

interface RegisterCustomersProps {
    onSuccess?: () => void;
    isUpdateMode?: boolean;
    userData?: any;
    updateEndpoint?: string;
}

const RegisterCustomers: React.FC<RegisterCustomersProps> = ({ 
    onSuccess, 
    isUpdateMode = false, 
    userData,
    updateEndpoint 
}) => {
    return (
        <div className="customer-registration-container">
            <Register 
                isForServiceProvider={true} 
                onSuccess={onSuccess} 
                isUpdateMode={isUpdateMode}
                userData={userData}
                updateEndpoint={updateEndpoint}
            />
        </div>
    );
};

export default RegisterCustomers;